import { configureStore } from '@reduxjs/toolkit'
import { timesheetApi } from './service/entries'
import { clientsApi } from './service/client'
import { baseApi } from '@/lib/utils'
import { configurationApi } from './service/configuration'

import { userManagementApi } from './service/userManagement'
import { milestoneAPi } from './service/milestone'
import { botApi } from './service/bot'
import { holidayApi } from './service/holiday'
import { weeklyPlanningApi } from './service/weeklyPlanning'
import { publicLeaveApi } from './service/publicLeave'
import { widgetsApi } from './service/widgets'

import themeReducer from './slices/themeSlice'

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [timesheetApi.reducerPath]: timesheetApi.reducer,
    [clientsApi.reducerPath]: clientsApi.reducer,
    [configurationApi.reducerPath]: configurationApi.reducer,
    [userManagementApi.reducerPath]: userManagementApi.reducer,
    [milestoneAPi.reducerPath]: milestoneAPi.reducer,
    [botApi.reducerPath]: botApi.reducer,
    [holidayApi.reducerPath]: holidayApi.reducer,
    [weeklyPlanningApi.reducerPath]: weeklyPlanningApi.reducer,
    [publicLeaveApi.reducerPath]: publicLeaveApi.reducer,
    [widgetsApi.reducerPath]: widgetsApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      baseApi.middleware,
      timesheetApi.middleware,
      clientsApi.middleware,
      configurationApi.middleware,
      userManagementApi.middleware,
      milestoneAPi.middleware,
      botApi.middleware,
      holidayApi.middleware,
      weeklyPlanningApi.middleware,
      publicLeaveApi.middleware,
      widgetsApi.middleware
    ),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
